import { IPromocodeItem } from "../../../../Bonus/types/bonusesActions";
import _ from "lodash";

export const calcDepositPromocodesBonusAmount = (amount: number, promocodeItem: IPromocodeItem | null) => {
    let bonusAmount: number;
    if (!promocodeItem) {
        bonusAmount = 0
    } else if (promocodeItem.amount_type === 'percent') {
        bonusAmount = promocodeItem.amount * amount / 100
    } else {
        bonusAmount = promocodeItem.amount
    }
    return bonusAmount
}

const calcDepositPromocodesBonusTotalAmount = (amount: number, promocodeItem: IPromocodeItem | null) => {
    let bonusAmount: number = calcDepositPromocodesBonusAmount(amount, promocodeItem);
    return _.round(+bonusAmount + +amount, 2);
}

export default calcDepositPromocodesBonusTotalAmount;
